module.exports = __webpack_public_path__ + "6aa4b7457e2acbd0c2a178f642c8be6f.png";